// extracted by mini-css-extract-plugin
export default {"container":"Tooltip_container__KoBUE","hidden":"Tooltip_hidden__BnXOc","tip":"Tooltip_tip__P3E9Y","top":"Tooltip_top__RmYhR","bottom":"Tooltip_bottom__VJGaJ"};